// OrderType
export const LENDER_APPRAISAL = "LenderAppraisal";
export const LENDER_NON_APPRAISAL = "LenderNonAppraisal";
export const INSURANCE = "Insurance"; // This is both terminology and order type
export const COMMERCIAL = "Commercial";

// Terminology
export const LENDER = "Lender";

// availablePaymentTypes
export const PAY_NOW = 1;
export const DEFER_PAYMENT = 2;
export const MUELLER_INVOICE = 3;